<!--
 * @FileDescription: 模板（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="template-page">
    <div class="template-page-botton">
      <div class="title">
        <h2>按钮</h2>
      </div>
      <div class="content-botton">
        <div class="content-row">
          <a-button>取消</a-button>
          <a-button type="primary">保存</a-button>
          <a-button type="primary" class="btn-save">保存</a-button>
          <a-button class="btn-save-next">保存并继续</a-button>
        </div>
        <div class="content-row">
          <a-button class="btn-cancel-disabled">取消</a-button>
          <a-button class="button-gray">保存</a-button>
          <a-button type="primary" class="button-search">查询</a-button>
        </div>
        <a-button class="btn-watch">预览</a-button>
        <a-button class="btn-edit">编辑</a-button>
      </div>
      <div class="content-botton">
        <div class="content-row">
          <a-button class="btn-purple">默认按钮</a-button>
        </div>
        <div class="content-row">
          <a-button class="border-arc button-gray">默认按钮</a-button>
        </div>
      </div>
      <div class="content-botton">
        <div class="content-row">
          <a-button type="primary" icon="plus">新增默认</a-button>
        </div>
        <div class="content-row">
          <a-button class="border-arc button-gray"
                    icon="plus">新增默认</a-button>
        </div>
      </div>
      <div class="content-botton">
        <div class="content-row">
          <a-button class="btn-add-temp"
                    icon="plus">新建模板</a-button>
        </div>
        <div class="content-row">
          <a-button class="btn-cancel-disabled"
                    icon="plus">新建模板</a-button>
        </div>
      </div>
    </div>
    <div class="template-page-input">
      <div class="title">
        <h2>输入框</h2>
      </div>
      <div class="content-row">
        <div class="content-input-row">
          <a-input placeholder="Basic usage"
                   class="filter-input" />
          <a-button type="primary"
                    class="border-arc input-botton">保存</a-button>
          <a-button type="primary"
                    class="border-arc input-botton">重置</a-button>
        </div>
        <div class="content-input-row"
             style="margin-top: 20px">
          <a-form :form="form"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }"
                  @submit="handleSubmit">
            <a-form-item label="菜单名称">
              <a-input placeholder="请输入菜单名称"
                       v-decorator="['title', { rules: [{ required: true, message: '请输入菜单名称' }] }]" />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
              <a-button type="primary"
                        html-type="submit">
                确定
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
    <div class="template-page-checkbox">
      <div class="title">
        <h2>选择</h2>
      </div>
      <div class="content-row">
        <span style="padding: 0 20px">单选：</span>
        <a-radio-group name="radioGroup"
                       :defaultValue="1"
                       @change="changeMenuType">
          <a-radio :value="1">一级菜单</a-radio>
          <a-radio :value="2">子菜单</a-radio>
          <a-radio :value="3">按钮</a-radio>
        </a-radio-group>
      </div>
      <div class="content-row"
           style="margin-top: 40px;display:flex">
        <span style="padding: 0 20px">多选：</span>
        <a-checkbox :indeterminate="indeterminate"
                    @change="onCheckAllChange"
                    :checked="checkAll">
          全选
        </a-checkbox>
        <a-checkbox :indeterminate="indeterminate1"
                    @change="onCheckAllChange1"
                    :checked="checkAll1">
          全选1
        </a-checkbox>
        <a-checkbox-group :options="plainOptions"
                          v-model="checkedList"
                          @change="onChange" />
        <a-checkbox :indeterminate="indeterminate2"
                    @change="onCheckAllChange2"
                    :checked="checkAll2">
          全选2
        </a-checkbox>
        <a-checkbox-group :options="plainOptions1"
                          v-model="checkedList1"
                          @change="onChange1" />
      </div>
    </div>
    <div class="template-page-tabs">
      <div class="title">
        <h2>tabs标签页</h2>
      </div>
      <div class="content-row">
        <a-tabs defaultActiveKey="1"
                @change="callback"
                class="a-tabs-theme">
          <a-tab-pane tab="Tab 1"
                      key="1">Content of Tab Pane 1</a-tab-pane>
          <a-tab-pane tab="Tab 2"
                      key="2"
                      forceRender>Content of Tab Pane 2</a-tab-pane>
          <a-tab-pane tab="Tab 3"
                      key="3">Content of Tab Pane 3</a-tab-pane>
        </a-tabs>
      </div>
      <div class="content-row">
        <a-tabs defaultActiveKey="1"
                @change="callback"
                class="a-tabs-white">
          <a-tab-pane tab="Tab 1"
                      key="1">Content of Tab Pane 1</a-tab-pane>
          <a-tab-pane tab="Tab 2"
                      key="2"
                      forceRender>Content of Tab Pane 2</a-tab-pane>
          <a-tab-pane tab="Tab 3"
                      key="3">Content of Tab Pane 3</a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div class="template-page-table">
      <div class="title">
        <h2>表格</h2>
      </div>
      <div class="content-row">
        <a-table :columns="columns"
                 :dataSource="dataSource"
                 bordered
                 rowKey="key">
          <template slot="operation"
                    slot-scope="text, record">
            <a class="table-redact"
               @click="btnEditMenu(record)">编辑</a>
          </template>
        </a-table>
      </div>
    </div>
    <div class="template-page-card">
      <h1>新增卡片</h1>
      <div class="add-card">
        <img src="@/assets/image/card-template@2x.png"
             class="add-card-left" />
        <div class="add-card-right">
          <a-button icon="plus"
                    class="add-card-right-btn">新增模板</a-button>
          <div class="add-card-right-text">点击上方按钮，新增模板</div>
        </div>
      </div>
      <div class="add-card">
        <img src="@/assets/image/dizhitianchong-@2x.png"
             class="add-card-left" />
        <div class="add-card-right">
          <a-button icon="plus"
                    class="add-card-right-btn">新增收货地址</a-button>
          <div class="add-card-right-text">点击上方按钮，新增收货地址</div>
        </div>
      </div>
      <div class="add-card">
        <img src="@/assets/image/xinzengjuese@2x.png"
             class="add-card-left" />
        <div class="add-card-right">
          <a-button icon="plus"
                    class="add-card-right-btn">新增角色</a-button>
          <div class="add-card-right-text">点击上方按钮，新增角色</div>
        </div>
      </div>
      <div class="add-card">
        <img src="@/assets/image/xinzengjuese@2x.png"
             class="add-card-left" />
        <div class="add-card-right">
          <a-button icon="plus"
                    class="add-card-right-btn">新增客户</a-button>
          <div class="add-card-right-text">点击上方按钮，新增客户</div>
        </div>
      </div>
    </div>
    <div class="template-page-dropdown">
      <h1>下拉菜单</h1>
      <a-range-picker @change="onChange3" />
      <a-select @change="handleChange"
                placeholder="选择">
        <a-icon slot="suffixIcon"
                type="caret-down" />
        <a-select-option value="jack">Jack</a-select-option>
        <a-select-option value="lucy">Lucy</a-select-option>
        <a-select-option value="disabled"
                         disabled>Disabled</a-select-option>
        <a-select-option value="Yiminghe">yiminghe</a-select-option>
      </a-select>
    </div>
    <div class="template-page-dropdown">
      <h1>弹框模板</h1>
      <div @click="onopenModel()">打开弹框</div>
      <model :width="680"
             :height="620"
             :title="title"
             ref="model"
             @onCofrim="onCofrimFormPower"
             @onCancel="onCancel"
             :isShow="isShowModel">
        <div>弹框模板</div>
      </model>
    </div>
    <div class="template-page-dropdown">
      <h1>图片模板</h1>
      <a-form-item label="企业logo">
        <v-picture v-decorator="['phone', { rules: [{ required: false, message: '' }] }]" @onChangeImg="onChangeImg"></v-picture>
      </a-form-item>
      <v-multiflePicture @onChangeImg="onChangeImg"></v-multiflePicture>
      <v-uploadFile @onChangeFile="onChangeFile"></v-uploadFile>
    </div>
      <v-picture @onChangeImg="onChangeImg"></v-picture>
      <j-editor  v-model="input" triggerChange  @change="changeEditor"/>
      <div v-html="editContent"></div>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import picture from "@/components/upload/picture.vue"
import multiflePicture from "@/components/upload/multiflePicture.vue"
import uploadFile from '@/components/upload/uploadFile'
import model from '@/components/model'
import JEditor from '@/components/JEditor'
export default {
  components: {
    model,
    'v-picture': picture,
    'j-editor':JEditor,
    'v-multiflePicture':multiflePicture,
    'v-uploadFile':uploadFile
  },
  data () {
    return {
      title: '弹框模板',
      isShowModel: false,
      input:'',
      editContent:'',
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 100,
          align: 'center',
          customRender (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          dataIndex: 'name',
          key: 'name',
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'Age',
          dataIndex: 'age',
          key: 'age',
        },
        {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
        },
        {
          title: 'Tags',
          key: 'tags',
          dataIndex: 'tags',
          scopedSlots: { customRender: 'tags' },
        },
        {
          title: 'Action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      dataSource: [
        {
          key: '1',
          name: 'John Brown',
          age: 32,
          address: 'New York No. 1 Lake Park',
          tags: ['nice', 'developer'],
        },
        {
          key: '2',
          name: 'Jim Green',
          age: 42,
          address: 'London No. 1 Lake Park',
          tags: ['loser'],
        },
        {
          key: '3',
          name: 'Joe Black',
          age: 32,
          address: 'Sidney No. 1 Lake Park',
          tags: ['cool', 'teacher'],
        },
      ],
      menuData: {
        title: '名称'
      },
      form: this.$form.createForm(this),
      indeterminate: false,
      indeterminate1: false,
      indeterminate2: false,
      checkAll: false,
      checkAll1: false,
      checkAll2: false,
      plainOptions: ['Apple', 'Pear', 'Orange'],
      plainOptions1: ['Apple', 'Pear', 'Orange'],
      checkedList: [],
      checkedList1: [],
    }
  },
  mounted () {
    this.setMenuData
  },
  methods: {
      //获取上传图片返回的链接
      onChangeImg(img){
          console.log(img)
      },
    onopenModel () {
      this.isShowModel = true
    },
    /**
    * @description: 此为方法注释（方法描述）
    * @param {参数类型} 参数名称
    * @return void
    */
    /**
     * @description: 时间选择（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    onChange3 (date, dateString) {
      console.log(date, dateString);
    },
    /**
     * @description: 下拉框选择（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    handleChange () {

    },
    callback () { },
    /**
      * @description: 赋值数据（方法描述）
      * @param {参数类型} 参数名称
      * @return void
      */
    setMenuData () {
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.menuData, 'title'))
      })
    },
    /**
      * @description: 提交表单，检查必填项（方法描述）
      * @param {参数类型} 参数名称
      * @return void
      */
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = {}
          formData.title = values.title
        }
      })
    },
    /**
      * @description: 单选（方法描述）
      * @param {Number} val：选菜单类型
      * @return void
      */
    changeMenuType (val) {
      console.log(val)
    },
    /**
      * @description: 多选（方法描述）
      * @param {Number} val：选菜单类型
      * @return void
      */
    onChange (checkedList) {
      this.indeterminate1 = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll1 = checkedList.length === this.plainOptions.length
      if (this.checkAll1) {
        this.checkAll = this.checkAll2 ? true : false
      } else {
        this.checkAll = false
      }
      console.log(this.indeterminate)
    },
    onChange1 (checkedList) {
      this.indeterminate2 = !!checkedList.length && checkedList.length < this.plainOptions1.length
      this.checkAll2 = checkedList.length === this.plainOptions1.length
      if (this.checkAll2) {
        this.checkAll = this.checkAll1 ? true : false
      } else {
        this.checkAll = false
      }
    },
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        checkedList1: e.target.checked ? this.plainOptions1 : [],
        indeterminate: false,
        indeterminate1: false,
        indeterminate2: false,
        checkAll: e.target.checked,
        checkAll1: e.target.checked,
        checkAll2: e.target.checked,
      })
    },
    onCheckAllChange1 (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate1: false,
        checkAll1: e.target.checked,
        checkAll: this.checkAll2 && e.target.checked ? true : false,
      })
      console.log(this.indeterminate)
    },
    onCheckAllChange2 (e) {
      Object.assign(this, {
        checkedList1: e.target.checked ? this.plainOptions1 : [],
        indeterminate2: false,
        checkAll2: e.target.checked,
        checkAll: this.checkAll1 && e.target.checked ? true : false,
      })
    },
    onCofrimFormPower () {
      this.isShowModel = false
    },
    onCancel () {
      this.isShowModel = false
    },
      changeEditor(value){
        this.editContent = value
      },
      onChangeFile(file){
        console.log(file)
      }

  },
}
</script>
<style lang="scss">
.template-page {
  .template-page-botton {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    background-color: #ffffff;
    .ant-btn {
      margin: 20px;
    }
  }
  .template-page-table {
    padding: 20px;
    margin: 20px 0;
    background-color: #ffffff;
  }
  .template-page-tabs {
    padding: 20px;
    background-color: #ffffff;
  }
  .template-page-input {
    padding: 20px;
    margin: 20px 0;
    background-color: #ffffff;
  }
  .template-page-card,
  .template-page-dropdown {
    padding: 20px;
    margin: 20px 0;
    background-color: #fff;
  }
  .template-page-dropdown {
    height: 500px;
  }
  .template-page-checkbox {
    padding: 20px;
    margin: 20px 0;
    background-color: #ffffff;
  }
}
</style>
